//check url to determine environment
const hostname = window.location.hostname;

const getEnv = (): 'local' | 'dev' | 'prod' => {
  if (hostname === 'localhost') return 'local';
  if (hostname === 'dev.dominusbaseball.com') return 'dev';
  return 'prod';
};

const env = getEnv();

export default env;